export default __webpack_public_path__ + "static/media/Software-Assembleias-Acionistas.fd554a38.png";